var cov_x7zj13m7e = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DataList/Pagination.tsx",
      hash = "6595a16a1224d24c04c4154d194f0351c6eae895",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DataList/Pagination.tsx",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 10,
          column: 3
        }
      },
      "1": {
        start: {
          line: 7,
          column: 27
        },
        end: {
          line: 7,
          column: 32
        }
      },
      "2": {
        start: {
          line: 8,
          column: 19
        },
        end: {
          line: 8,
          column: 56
        }
      },
      "3": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 32
        }
      }
    },
    fnMap: {
      "0": {
        name: "Pagination",
        decl: {
          start: {
            line: 5,
            column: 24
          },
          end: {
            line: 5,
            column: 34
          }
        },
        loc: {
          start: {
            line: 5,
            column: 107
          },
          end: {
            line: 11,
            column: 1
          }
        },
        line: 5
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 6,
            column: 9
          },
          end: {
            line: 6,
            column: 10
          }
        },
        loc: {
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 10,
            column: 3
          }
        },
        line: 6
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 19
          },
          end: {
            line: 8,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 8,
            column: 32
          },
          end: {
            line: 8,
            column: 47
          }
        }, {
          start: {
            line: 8,
            column: 50
          },
          end: {
            line: 8,
            column: 56
          }
        }],
        line: 8
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DataList/Pagination.tsx";
import React from 'react';
import pagable from '../hoc/pagable';
export default function Pagination(Origin) {
  var _this = this;

  cov_x7zj13m7e.f[0]++;
  cov_x7zj13m7e.s[0]++;
  return function (props) {
    cov_x7zj13m7e.f[1]++;

    var _ref = (cov_x7zj13m7e.s[1]++, props),
        pagination = _ref.pagination;

    var Render = (cov_x7zj13m7e.s[2]++, pagination ? (cov_x7zj13m7e.b[0][0]++, pagable(Origin)) : (cov_x7zj13m7e.b[0][1]++, Origin));
    cov_x7zj13m7e.s[3]++;
    return (
      /*#__PURE__*/
      React.createElement(Render, Object.assign({}, props, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 9,
          columnNumber: 12
        }
      }))
    );
  };
}